import { useEffect } from 'react';

/**
 * Observa todo lo que lleve [data-reveal] y le pone [data-revealed]
 * cuando entra en pantalla. Un solo observer para la pagina entera.
 * Si el sistema pide menos movimiento, revela todo de inmediato.
 */
export default function useReveal() {
  useEffect(() => {
    const nodos = Array.from(document.querySelectorAll('[data-reveal]'));
    if (!nodos.length) return undefined;

    const quieto = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    if (quieto || typeof IntersectionObserver === 'undefined') {
      nodos.forEach((n) => n.setAttribute('data-revealed', ''));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          entrada.target.setAttribute('data-revealed', '');
          observer.unobserve(entrada.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    nodos.forEach((n) => observer.observe(n));
    return () => observer.disconnect();
  }, []);
}
